import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import get from "lodash/get";
import { setUserDetails } from "../../store/actions";
import { putUserDetails } from "../../helper/utils";

import "./puzzle-contest.m.css";
import Modal from "../../atoms/modal";
import { TERMS_CONDITIONS } from "./terms-conditions";
import { Link } from "@quintype/components";
import { pushEventToDataLayer } from "../../helper/datalayer-utils";

function PuzzleContestPage() {
  const [loadPuzzle, setLoadPuzzle] = useState(false);
  const userdetails = useSelector((state) => get(state, ["user", "user"], {}));
  const ssoEndpoint = useSelector((state) =>
    get(state, ["qt", "config", "publisher-attributes", "sso_endpoint"], null)
  );
  const [currentScreen, setCurrentScreen] = useState("");
  const [isMobile, setMobile] = useState(false);
  const [redirectUrl, setRedirectUrl] = useState("");

  useEffect(() => {
    if (window && window.innerWidth < 767) {
      setMobile(true);
    } else {
      setMobile(false);
    }
    if (window) {
      const url = window.location.href.split("?")[0];
      setRedirectUrl(url);
    }
  }, []);

  const previousScreen = useRef(null);

  const setCurrentScreenWithRefUpdate = (newScreen) => {
    previousScreen.current = currentScreen;
    setCurrentScreen(newScreen);
  };
  console.log("userdetails>>", userdetails);

  useEffect(() => {
    if (window) {
      const access_token = localStorage.getItem("access_token");
      if (access_token) {
        if (userdetails?.userData?.id) {
          if (
            userdetails?.metadata?.address &&
            userdetails?.metadata?.displayName &&
            userdetails?.userData?.phoneNumbers[0]
          ) {
            setCurrentScreenWithRefUpdate("");
            setLoadPuzzle(true);
          } else {
            setCurrentScreenWithRefUpdate("form");
          }
        }
      } else {
        setCurrentScreenWithRefUpdate("start");
      }
    }
  }, [userdetails?.userData?.id]);

  useEffect(() => {
    if (document && loadPuzzle) {
      const embedDiv = document.getElementsByClassName("pm-embed-div")[0];
      console.log("embedDiv puzzle >>", embedDiv);
      if (embedDiv) {
        window.embedGame();
      }
    }
  }, [loadPuzzle]);

  const clickHandler = (type) => {
    switch (type) {
      case "start-continue":
        setCurrentScreenWithRefUpdate("info");
        break;
      case "info-no":
        if (previousScreen.current === "start") {
          setCurrentScreenWithRefUpdate("start");
        } else {
          setCurrentScreenWithRefUpdate("form");
        }
        break;
      case "info-yes":
        setCurrentScreenWithRefUpdate("");
        setLoadPuzzle(true);
        break;
      case "form-cancel":
        setCurrentScreenWithRefUpdate("info");
        break;
      default:
        break;
    }
  };

  function StartScreen() {
    const signinHandler = () => {
      if (window?.dataLayer) pushEventToDataLayer("SSO_Page_Open");
      const mobileCallOutText = "Please enter the mobile number you wish to use with the account.";
      window.location.href = `${ssoEndpoint}/auth?redirectUrl=${redirectUrl}&phoneNumberRequired=true&signupMessage=${mobileCallOutText}`;
    };
    return (
      <div styleName="button-screen-wrapper">
        <span styleName="cross-word-button-screen-title">Sign in or create an account to participate</span>
        <button styleName="cross-word-signin" onClick={signinHandler}>
          Sign In
        </button>
        {/* <button styleName="cross-word-continue" onClick={() => clickHandler("start-continue")}>
          Continue Without Sign In
        </button> */}
      </div>
    );
  }

  function InfoScreen() {
    return (
      <>
        <span styleName="cross-word-info-screen-title">
          Proceeding without providing your details will make you ineligible for winning the contest. Are you sure you
          want to proceed without providing details?
        </span>
        <div styleName="info-buttons-wrapper">
          <button styleName="cross-word-info-no" onClick={() => clickHandler("info-no")}>
            No
          </button>
          <button styleName="cross-word-info-yes" onClick={() => clickHandler("info-yes")}>
            Yes
          </button>
        </div>
      </>
    );
  }

  function FormScreen({ openTermsHandler }) {
    // const [filteredRecords, setFilteredRecords] = useState([]);
    const modalRef = useRef(null);
    // const [collegeName, setCollegeName] = useState("");
    const [studentName, setStudentName] = useState(userdetails?.metadata?.displayName || "");
    const [address, setAddress] = useState(userdetails?.metadata?.address || "");
    const [phoneNumber, setPhoneNumber] = useState(userdetails?.userData?.phoneNumbers[0] || "");
    const [disable, setDisable] = useState(true);
    const [openModal, setModal] = useState(false);
    const dispatch = useDispatch();
    const mobileNumber = userdetails?.userData?.phoneNumbers[0];

    useEffect(() => {
      const clikedOutsideModal = (event) => {
        if (modalRef.current && !modalRef.current.contains(event.target)) {
          setModal(false);
        }
      };
      document.addEventListener("mousedown", clikedOutsideModal);
      return () => document.removeEventListener("mousedown", clikedOutsideModal);
    }, [modalRef]);

    useEffect(() => {
      if (phoneNumber.trim() === "" || studentName.trim() === "" || address.trim() === "") {
        setDisable(true);
      } else {
        setDisable(false);
      }
    }, [phoneNumber, address, studentName]);

    const updateUserdetails = async () => {
      const data = {
        ...userdetails?.metadata,
        address: address,
        displayName: studentName
      };
      setDisable(true);
      const details = await putUserDetails(data);
      let localUserData;
      const user = window?.localStorage?.getItem("user");
      if (user !== "undefined") {
        if (typeof user === "string" && user.trim() !== "") {
          localUserData = JSON.parse(user);
        }
      }

      window.localStorage.setItem(
        "user",
        JSON.stringify({ ...localUserData, metadata: { ...localUserData?.metadata, ...details } })
      );
      dispatch(setUserDetails({ ...userdetails, metadata: { ...userdetails?.metadata, ...details } }));
      setDisable(false);
      setCurrentScreenWithRefUpdate("");
      setLoadPuzzle(true);
    };

    const phoneNumberUpdateHandler = () => {
      updateUserdetails();
      if (userdetails?.userData?.phoneNumbers[0] == undefined) {
        setCurrentScreenWithRefUpdate("");
        const mobileCallOutText = `Please enter the mobile number you wish to use with the account. ${phoneNumber}`;

        window.location.href = `${ssoEndpoint}/auth/change_phonenumber?redirectUrl=${redirectUrl}&emailRequired=false&signupMessage=${mobileCallOutText}&isFrom=profile`;
      }
    };
    return (
      <div styleName="form-wrapper">
        <span styleName="cross-word-form-title">Update Profile</span>
        <span styleName="cross-word-form-name-label">Name *</span>
        <input
          type="text"
          styleName="cross-word-form-name-field"
          value={studentName}
          onChange={(e) => {
            setStudentName(e.target.value);
          }}
        ></input>
        <span styleName="cross-word-form-college-label">Address(City) *</span>
        <input
          type="text"
          styleName="cross-word-form-name-field"
          value={address}
          onChange={(e) => {
            setAddress(e.target.value);
          }}
        ></input>
        <span styleName="cross-word-form-college-label">Phone Number *</span>
        <div styleName="cross-word-phone-number-wrapper">
          <input
            placeholder="Mobile Number"
            disabled={userdetails?.userData?.phoneNumbers[0]}
            type="text"
            styleName="cross-word-form-name-field"
            value={phoneNumber}
            onChange={(e) => {
              setPhoneNumber(e.target.value);
            }}
          ></input>
        </div>

        <div styleName="term-condition-wrapper">
          <input type="checkbox" checked={true} disabled />
          <span styleName="condition-text">
            I agree to <span onClick={openTermsHandler}>Terms & Conditions</span> of Puzzle Quiz
          </span>
        </div>

        <div styleName="info-buttons-wrapper">
          <button styleName="cross-word-form-save" onClick={phoneNumberUpdateHandler} disabled={disable}>
            Continue
          </button>
        </div>
      </div>
    );
  }

  const [termConditionModal, setTermCondtionModal] = useState(false);

  const termConditionModalOpenHandler = () => setTermCondtionModal(true);
  const termConditionModalCloseHandler = () => setTermCondtionModal(false);

  useEffect(() => {
    if (!loadPuzzle) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "visible";
    }
    return () => {
      document.body.style.overflow = "visible";
    };
  }, [loadPuzzle]);

  const handleUpdateClick = () => {
    if (window) {
      window.location.reload();
    }
  };

  return (
    <div styleName="student-contest-wrapper">
      <div styleName="title-wrapper">
        <div styleName="puzzle-logo">
          <img src="https://images.assettype.com/deccanherald-training/2025-09-24/rbyvc0wj/image-1.png"></img>
        </div>
        <div styleName="puzzle-headline-wrapper">
          <h1 styleName="headline">
            Mysore Dasara | DH News Quiz, in partnership with the Indira Gandhi Centre for Career Development (IGCCD)
          </h1>
          <span styleName="description">
            An engaging 90-day challenge starting on September 22, 2025, where students can participate by answering
            daily quiz questions to win exciting prizes during the celebration of Mysore Dasara Festival 2025.
          </span>
        </div>
      </div>
      <div styleName="widget-wrapper">
        {loadPuzzle && currentScreen === "" ? (
          userdetails?.userData?.id && userdetails?.metadata?.displayName ? (
            <div styleName="widget">
              <div
                data-uid={userdetails?.userData?.id}
                className="pm-embed-div"
                data-set="dhcirculation-igccd"
                data-page="date-picker"
                data-height={isMobile ? "1020px" : "750px"}
                data-embedparams="embed=js&style=1"
              ></div>
            </div>
          ) : (
            <div styleName="widget">
              <div
                className="pm-embed-div"
                data-set="dhcirculation-igccd"
                data-page="date-picker"
                data-height={isMobile ? "1020px" : "750px"}
                data-embedparams="embed=js&style=1"
              ></div>
            </div>
          )
        ) : (
          <h2 styleName="waiting-text">Wait for the widget to load...</h2>
        )}
      </div>

      {!loadPuzzle && (
        <div styleName="overlay">
          <div styleName="contest-dialogue-box">
            {currentScreen === "" ? (
              <span>Loading...</span>
            ) : (
              <>
                {currentScreen === "start" && <StartScreen />}
                {currentScreen === "info" && <InfoScreen />}
                {currentScreen === "form" && <FormScreen openTermsHandler={termConditionModalOpenHandler} />}
              </>
            )}
          </div>
          <div styleName="term-condition-modal">
            <Modal onClose={termConditionModalCloseHandler} isOpen={termConditionModal}>
              <h2 styleName="title">Terms & Conditions</h2>
              <div styleName="term-condition-inner">
                <div styleName="subtitle">
                  Mysore Dasara - Deccan Herald News Quiz  in association with the Indira Gandhi Centre for Career
                  Development (IGCCD) ,90 days Starting on 22 nd sep 2025
                </div>
                <div styleName="dialogue-close" onClick={termConditionModalCloseHandler}>
                  &#10005;
                </div>
                {TERMS_CONDITIONS.map((term, index) => {
                  const { termTitle, subTerms } = term;
                  return (
                    <div key={index}>
                      <span styleName="term-title">
                        {index + 1}. {termTitle}
                      </span>
                      <ul styleName="subterms-wrapper">
                        {subTerms.map((subTerm, idx) => (
                          <li styleName="subterm" key={idx}>
                            {subTerm}
                          </li>
                        ))}
                      </ul>
                    </div>
                  );
                })}
                <span styleName="contact">
                  For any queries or further information, please contact us at{" "}
                  <Link href="mailto:support@deccanherald.co.in">support@deccanherald.co.in</Link>
                </span>
              </div>
            </Modal>
          </div>
        </div>
      )}
    </div>
  );
}

export { PuzzleContestPage };
